import RsaFatturazioneListPage from "./pages/RsaFatturazioneListPage.vue";
import RsaFatturazioneDettaglioListPage from "./pages/RsaFatturazioneDettaglioListPage.vue";

export default {
    RsaFatturazioneListPage,
    RsaFatturazioneDettaglioListPage,
};
